import { ArcgaugeComponent } from './arc-gauge.component';

export const ARCGAUGE_DECLARATIONS: any[] = [ArcgaugeComponent];
